import emailVerificationService from '../services';
import {
  setEmailVerificationError,
  setIsLoadingVerificationEmail,
} from '../store-actions/email-verification-store-actions';

export const sendEmailVerification = async () => {
  setIsLoadingVerificationEmail(true);
  setEmailVerificationError(null);
  const emailVerification =
    await emailVerificationService.sendEmailVerification.execute();

  if (!emailVerification) {
    setEmailVerificationError(
      'Failed to send verification email, please try again later.',
    );
  }
  setIsLoadingVerificationEmail(false);
};
